import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import Colors from '../../assets/Colors';

export default function SearchDefault() {
  return (
    <View style={styles.card}>
      <Text style={styles.title}>Ricerca quello che desideri</Text>
      <View style={styles.info}>
        <Text style={styles.text}>Qui puoi ricercare un nostro prodotto.</Text>
        <Text style={styles.text}>Ricerca in base a:</Text>
        <View style={styles.sectionText}>
          <Text>{'\u2022'}</Text>
          <Text style={styles.itemText}>
            Titolo dell'album o nome artista
          </Text>
        </View>
        <View style={styles.sectionText}>
          <Text>{'\u2022'}</Text>
          <Text style={styles.itemText}>
            Genere musicale
          </Text>
        </View>
        <View style={styles.sectionText}>
          <Text>{'\u2022'}</Text>
          <Text style={styles.itemText}>
            Tipo prodotto
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    marginTop: 30,
    flex: 1,
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 15,
    overflow: 'hidden',
    marginBottom: 10,
    minHeight: 110,
    backgroundColor: '#fff',
  },
  title: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 18,
    paddingTop: 10,
  },
  info: {
    flex: 1,
    padding: 10,
    paddingHorizontal: 20,
  },
  text: {
    padding: 2,
  },
  sectionText: {
    flexDirection: 'row',
    paddingHorizontal: 13,
    paddingBottom: 2,
  },
  itemText: {
    marginLeft: 3,
  },
});
